'use client';
import React from 'react';
import Link from 'next/link';
import AppImage from '@/components/ui/AppImage';
import { MapPin, Clock } from 'lucide-react';

interface ClassifiedItem {
  id: string;
  title: string;
  price: string;
  location: string;
  timeAgo: string;
  image: string;
  alt: string;
  condition: string;
  conditionColor: string;
}

const recentItems: ClassifiedItem[] = [
{
  id: 'cls-001', title: 'Samsung Galaxy S24 Ultra', price: 'KES 142,000',
  location: 'Kilimani', timeAgo: '5 min ago', condition: 'New',
  conditionColor: '#00C853',
  image: "https://images.unsplash.com/photo-1707410420102-faff6eb0e033",
  alt: 'Black Samsung Galaxy S24 Ultra smartphone on white surface'
},
{
  id: 'cls-002', title: 'Leather Sofa Set 7-Seater', price: 'KES 85,000',
  location: 'South B', timeAgo: '12 min ago', condition: 'Used',
  conditionColor: '#FFB300',
  image: "https://images.unsplash.com/photo-1646462778394-32985c3d566f",
  alt: 'Brown leather sofa set arranged in a modern living room'
},
{
  id: 'cls-003', title: 'Yamaha FZ16 2022 Motorbike', price: 'KES 185,000',
  location: 'Eastleigh', timeAgo: '25 min ago', condition: 'Used',
  conditionColor: '#FFB300',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_107f44db4-1772638688721.png",
  alt: 'Blue Yamaha FZ16 motorbike parked on a street'
},
{
  id: 'cls-004', title: 'MacBook Pro M3 14-inch', price: 'KES 210,000',
  location: 'Gigiri', timeAgo: '1 hr ago', condition: 'New',
  conditionColor: '#00C853',
  image: "https://images.unsplash.com/photo-1515803171005-2d5e90f7b4d3",
  alt: 'Silver MacBook Pro laptop open on a desk with coffee'
},
{
  id: 'cls-005', title: 'Ankara Dress Collection (10 pcs)', price: 'KES 12,500',
  location: 'Gikomba', timeAgo: '2 hrs ago', condition: 'New',
  conditionColor: '#00C853',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_1158e7cf7-1775230476446.png",
  alt: 'Colorful Ankara print dresses hanging on rack in market'
},
{
  id: 'cls-006', title: 'Dairy Cow — Friesian Cross', price: 'KES 95,000',
  location: 'Nakuru', timeAgo: '3 hrs ago', condition: 'N/A',
  conditionColor: '#6B7A99',
  image: "https://images.unsplash.com/photo-1549995177-8f92d78d1751",
  alt: 'Black and white Friesian dairy cow standing in a green field'
}];


export default function RecentClassifieds() {
  return (
    <div>
      <div className="flex items-center justify-between mb-3">
        <h2 className="text-base font-700 text-foreground">Recent Classifieds</h2>
        <Link href="/classifieds-screen" className="text-xs font-600" style={{ color: 'var(--primary)' }}>
          See all
        </Link>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 gap-3">
        {recentItems.map((item) =>
        <Link key={item.id} href={`/product/${item.id}`} className="listing-card">
            <div className="relative">
              <AppImage src={item.image} alt={item.alt} width={200} height={130}
            className="w-full h-32 object-cover" />
              <span className="absolute top-2 left-2 px-1.5 py-0.5 rounded-full text-[9px] font-700"
            style={{ background: item.conditionColor, color: '#000' }}>
                {item.condition}
              </span>
            </div>
            <div className="p-2.5">
              <p className="text-xs font-600 text-foreground truncate mb-1">{item.title}</p>
              <p className="text-sm font-800 font-tabular mb-1.5" style={{ color: 'var(--primary)' }}>{item.price}</p>
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-1">
                  <MapPin size={10} style={{ color: 'var(--muted-foreground)' }} />
                  <span className="text-[10px]" style={{ color: 'var(--muted-foreground)' }}>{item.location}</span>
                </div>
                <div className="flex items-center gap-1">
                  <Clock size={10} style={{ color: 'var(--muted-foreground)' }} />
                  <span className="text-[10px]" style={{ color: 'var(--muted-foreground)' }}>{item.timeAgo}</span>
                </div>
              </div>
            </div>
          </Link>
        )}
      </div>
    </div>);

}